// extracted by mini-css-extract-plugin
export default {"Inputs":"styles_Inputs__36Jd3","Inputs__statusSearch":"styles_Inputs__statusSearch__uyXx0"};